import MultipleSelect from "../../../Components/CluppForms/MultipleSelect";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";

const DontLikeClupp = ({ state, setState, field }) => {
  const options = state.isMoreThanOne
    ? [
        {
          id: `La atencion a los clientes`,
          label: `La atencion a los clientes`,
          value: `La atencion a los clientes`,
        },
        {
          id: "No me dio confianza",
          label: "No me dio confianza",
          value: "No me dio confianza",
        },
        {
          id: "El precio",
          label: "El precio",
          value: "El precio",
        },

        { id: "Otro", label: "Otro (escribe tu razón)", value: "" },
      ]
    : [
        {
          id: `La atencion a los clientes`,
          label: `La atencion a los clientes`,
          value: `La atencion a los clientes`,
        },
        {
          id: "No me dio confianza",
          label: "No me dio confianza",
          value: "No me dio confianza",
        },
        {
          id: "El precio",
          label: "El precio",
          value: "El precio",
        },
        {
          id: "No me gustó estar subiendo fotos del odómetro",
          label: "No me gustó estar subiendo fotos del odómetro",
          value: "No me gustó estar subiendo fotos del odómetro",
        },
        { id: "Otro", label: "Otro (escribe tu razón)", value: "" },
      ];

  return (
    <>
      <TitleHeaders
        title={"¿Qué fue lo que no te gustó del seguro de clupp?"}
        subtitle={"Por favor, selecciona una de las siguientes opciones."}
        isRequired={true}
      />

      <MultipleSelect
        options={options}
        state={state}
        setState={setState}
        field={field}
        isMultiple={false}
        haveOtherTextField={true}
      />
    </>
  );
};

export default DontLikeClupp;
